import React from 'react';
import { Container, Title, Table } from './styled';

const ImpossiblePlayer = ({ data }) => {
  return (
    <Container>
      <Title>출전 불가</Title>
      <Table>
        <colgroup>
          <col width={150} />
          <col width={70} />
          <col width={160} />
          <col />
        </colgroup>
        <thead>
          <tr>
            <th>선수명</th>
            <th>포지션</th>
            <th>불가사유</th>
            <th>상세내용</th>
          </tr>
        </thead>
        <tbody>
          {data.map((value, key) => {
            const { player, reason, detail } = value;
            return (
              <tr key={key}>
                <td>{player.displayName}</td>
                <td>{player.position}</td>
                <td>{reason}</td>
                <td>{detail}</td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </Container>
  );
};

export default ImpossiblePlayer;
